import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getBanks: () => ({
    url: 'DirectDebit/api/v1/banks',
    method: 'GET',
  }),
  createContract: (input) => ({
    url: 'DirectDebit/api/v2/Contracts',
    method: 'POST',
    data: input,
  }),
  getDirectDebits: () => ({
    url: 'DirectDebit/api/v1/Schedules',
    method: 'GET',
  }),
  removeDirectDebit: (input) => ({
    url: `DirectDebit/api/v1/Contracts/${input.contractNo}`,
    method: 'DELETE',
  }),
  getDirectDebitsTransactions: (input) => ({
    url: `DirectDebit/api/v1/Transactions`,
    method: 'GET',
    params: {
      bank: input?.bankId,
      pageSize: input?.pageSize,
      pageIndex: input?.pageIndex,
      transactionStatus: input?.transactionStatus,
    },
  }),
  createAutoInvest: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/Contracts/Insert`,
    method: 'POST',
    data: input,
  }),
  deactivateAutoInvestSchedule: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/Contracts/User/${input?.trackingId}/inactive`,
    method: 'POST',
    data: input,
  }),
  activateAutoInvestSchedule: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/Contracts/User/${input?.trackingId}/Active`,
    method: 'POST',
    data: input,
  }),
  shahkarCheck: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/BaseInfos/ShahkarCheck`,
    method: 'POST',
    data: input,
  }),
  getUserContractHamiProfit: (input) => ({
    url: `DirectDebit/api/v1/AutoInvest/Contracts/GetUserContractHamiProfit`,
    method: 'GET',
    data: input,
  }),
  efficiencyCalculator: (input) => ({
    url: `directDebit/api/v1/autoInvest/baseInfos/efficiencyCalculator`,
    method: 'POST',
    data: input,
  }),
};

export default apis;
